module.exports = __webpack_public_path__ + "img/sunshine-page_320.9a2a38a2.png";